import { AttributeValue } from '@opentelemetry/api';

const PII_ATTRIBUTE_KEY_PATTERN =
  /(first[_-]?name|last[_-]?name|email|phone|serial|model[_-]?number|address|postal|city|state|country|purchase[_-]?(price|date))/i;

export const sanitizeSpanAttributes = (
  data: Record<string, AttributeValue>,
): Record<string, AttributeValue> => {
  return Object.entries(data).reduce<Record<string, AttributeValue>>((attributes, [key, value]) => {
    if (!PII_ATTRIBUTE_KEY_PATTERN.test(key)) {
      attributes[key] = value;
    }

    return attributes;
  }, {});
};
